import React from "react";

import { Card } from "@/components/ui/card";
// import useUpdateQueryParams from "@/hooks/use-update-query-params";
import { useSearchParams } from "react-router";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import NoDataFound from "@/components/layout/no-data-found";
import { useGetAgentChatRequests } from "@/api/agent-chat/useGetAgentChatRequests.tsx";
import ChatRequest from "../chat-request/chat-request";

interface ChatRequestListProps {
    className?: string;
    connectWebSocket?: any;
    sendMessage?: (message: string) => void;
    isConnected?: boolean;
}

interface ChatSession {
    session_id: string;
    status: string;
    chat_request: string;
    store_id: string;
}

const ChatRequestList: React.FC<ChatRequestListProps> = ({ className, connectWebSocket, sendMessage, isConnected }) => {
    // const updateQueryParams = useUpdateQueryParams();
    const [searchParams] = useSearchParams();

    // const [chatSessions, setChatSessions] = useState<ChatSession[]>([]);

    // React.useEffect(() => {
    //     if (!searchParams.has("chat_id") && chatSessions?.length > 0) {
    //         updateQueryParams({ chat_id: chatSessions[0]?.session_id });
    //     }
    // }, [searchParams, updateQueryParams, chatSessions]);

    const { data: sessions, isLoading } = useGetAgentChatRequests();

    // useEffect(() => {
    //     setChatSessions(sessions?.data);
    // }, [sessions]);

    return (
        <Card className={cn("h-auto lg:h-[calc(100vh-80px)] overflow-y-auto scroll-smooth border", className)}>
            <div className="z-10 sticky top-0 flex items-center justify-between rounded-t-xl border-b bg-white p-4">
                <h6 className="font-semibold">Chat Requests</h6>
            </div>
            <div className="flex p-2 md:p-4 lg:flex-col justify-center">
                {sessions?.data?.length === 0 && (
                    // <div>
                    //     <h3 className="text-center font-semibold text-slate-700">No Conversations</h3>
                    // </div>
                    <NoDataFound message="No Chat Request Found" />
                )}
                {isLoading &&
                    [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                        <div className="flex items-center space-x-4 my-4" key={item}>
                            <Skeleton className="h-12 w-12 rounded-full" />
                            <div className="space-y-2">
                                <Skeleton className="h-4 w-[250px]" />
                                <Skeleton className="h-4 w-[200px]" />
                            </div>
                        </div>
                    ))}
                {sessions?.data?.length > 0 &&
                    sessions?.data?.map((session: ChatSession, index: number) => (
                        <ChatRequest
                            index={index}
                            key={session?.session_id}
                            name={session?.chat_request}
                            lastMessage={session?.status === "pending" ? "Waiting for agent response" : ""}
                            active={searchParams.get("chat_id") === session?.session_id}
                            id={session?.chat_request}
                            connectWebSocket={connectWebSocket}
                            sendMessage={sendMessage}
                            isConnected={isConnected}
                        />
                    ))}
            </div>
        </Card>
    );
};

export default ChatRequestList;
